@media screen and (width >= 600px) {
  .container {
    width: min-content;
  }
}
